import { TabPanel } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const Tabs = ({ tabs, alignment = 'horizontal', renderTab }) => {
    return (
        <TabPanel
            className={`voxycure-tabs voxycure-card voxycure-tabs--${alignment}`}
            activeClass="is-active"
            tabs={tabs}
        >
            {(tab) => renderTab(tab)}
        </TabPanel>
    );
};

export default Tabs;
